export default __webpack_public_path__ + "static/media/5.66d04846.png";